import { GridColDef } from '@mui/x-data-grid-pro';
import { GridValidRowModel } from '@mui/x-data-grid/models/gridRows';
import { GridPreProcessEditCellProps } from '@mui/x-data-grid/models/params/gridCellParams';

import { gridDateTimeFormatter, mapGridIndexes, newGridRecordId } from '@shared/commonFunctions';
import { gridBooleanCell, dataGridCol, gridCurrencyCell } from '@shared/components/grid/common';
import { PhoenixGrid } from '@shared/components/grid/PhoenixGrid';
import { GridColNumber } from '@shared/components/grid/GridColNumber';
import { GridColTextInput } from '@shared/components/grid/GridColTextInput';

import { TDealFee } from '../../../interfaces';
import { additionalDocFeesValidationSchema } from '../../../validation';
import { requestCreateDealFee, requestDeleteDealFee, requestUpdateDealFee } from './queries';

interface IDocFeesAdditionalTableProps {
  lenderId: string;
  data: TDealFee[];
}

export const DocFeesAdditionalTable = ({ data = [], lenderId }: IDocFeesAdditionalTableProps) => {
  const preProcessPositiveValue = ({ props }: GridPreProcessEditCellProps) => ({
    ...props,
    error: props.value < 0,
  });

  const columns: GridColDef[] = [
    dataGridCol('category', { renderEditCell: (params) => <GridColTextInput params={params} /> }),
    dataGridCol('description', { renderEditCell: (params) => <GridColTextInput params={params} /> }),
    dataGridCol('amount', {
      ...gridCurrencyCell,
      type: 'number',
      renderEditCell: (params) => <GridColNumber prefix="$" params={params} decimalScale={2} />,
    }),
    dataGridCol('minFico', {
      preProcessEditCellProps: preProcessPositiveValue,
      renderEditCell: (params) => <GridColNumber limit={5} params={params} />,
    }),
    dataGridCol('maxFico', {
      preProcessEditCellProps: preProcessPositiveValue,
      renderEditCell: (params) => <GridColNumber limit={5} params={params} />,
    }),
    dataGridCol('isCurrent', gridBooleanCell),
    dataGridCol('isIncluded', gridBooleanCell),
    dataGridCol('isDocFee', gridBooleanCell),
    dataGridCol('createdDate', {
      type: 'dateTime',
      editable: false,
      minWidth: 240,
      valueFormatter: gridDateTimeFormatter,
    }),
  ].map((column) => ({ minWidth: 100, editable: true, flex: 1, ...column }));

  const gridActions = {
    onSave: (row: GridValidRowModel) =>
      row?.id === newGridRecordId ? requestCreateDealFee(lenderId, row) : requestUpdateDealFee(lenderId, row),
    onDelete: (row: GridValidRowModel) => requestDeleteDealFee(lenderId, row?.id),
  };

  return (
    <PhoenixGrid
      autoHeight
      withHeader
      name="Additional Doc Fee"
      height="auto"
      gridId={`Additional Doc Fee-${lenderId}`}
      pageSize={5}
      columns={columns}
      loading={!data}
      validateSchema={additionalDocFeesValidationSchema}
      rows={mapGridIndexes(data)}
      actions={gridActions}
    />
  );
};
